import { createAction } from '@reduxjs/toolkit';

export const getStoreSummaryRequest = createAction('GET_STORE_SUMMARY_REQUEST', (merchantId) => {
    return {
        payload: {
            merchantId
        }
    }
});


export const getStoreSummarySuccess = createAction('GET_STORE_SUMMARY_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const getStoreSummaryFailure = createAction('GET_STORE_SUMMARY_FAILURE', error => {
    return {
        payload: {
            error
        }
    }
});

export const getSingleStoreDetailsRequest = createAction('GET_SINGLE_STORE_DETAILS_REQUEST', (merchantId, storeUUID, sourceId) => {
    return {
        payload: {
            merchantId,
            storeUUID,
            sourceId,
        }
    }
});


export const getSingleStoreDetailsSuccess = createAction('GET_SINGLE_STORE_DETAILS_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const getSingleStoreDetailsFailure = createAction('GET_SINGLE_STORE_DETAILS_FAILURE', error => {
    return {
        payload: {
            error
        }
    }
});

export const selectedStoreRequest = createAction('GET_SELECTED_STORE', (storeId, storeUUID, sourceId) => {
    return {
        payload: {
            storeId,
            storeUUID,
            sourceId
        }
    }
});


export const getMerchantIdRequest = createAction('GET_MERCHANT_ID_REQUEST', (merchantId) => {
    return {
        payload: {
            merchantId
        }
    }
});


export const getMerchantIdSuccess = createAction('GET_MERCHANT_ID_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const getMerchantIdFailure = createAction('GET_MERCHANT_ID_FAILURE', error => {
    return {
        payload: {
            error
        }
    }
});
